var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify-md":"center"}},[_c('v-col',{attrs:{"sm":"10","md":"7"}},[_c('h1',[_vm._v("Email Verified. You're in!")]),_c('p',[_vm._v("Now go jump back into our games and have some fun!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }